import {MODIFICAR_COTIZADOR} from '../types';

const initialState = {
    cotizador: true
}

export default function(state = initialState, action){
    switch(action.type){
        case MODIFICAR_COTIZADOR:
            return{
                ...state,
                cotizador: action.payload
            }    
        default: 
            return state
    }
}

